// ProtectedRoute.js
import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from './context/AuthContext';

const ProtectedRoute = ({ children, requiredPermission = null }) => {
  const { user, loading, can } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!loading && !user) {
      navigate('/admin/login', { state: { from: location } });
    }
  }, [loading, user, navigate, location]);

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center h-screen gap-4">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
        <p className="text-gray-600">Verifying authentication...</p>
      </div>
    );
  }

  if (!user) {
    return null; // Will redirect in useEffect
  }

  // Permission Check
  if (requiredPermission && !can(requiredPermission)) {
     // User is logged in but doesn't have permission
     return (
        <div className="flex flex-col items-center justify-center h-screen gap-4">
           <h1 className="text-2xl font-bold text-red-600">Access Denied</h1>
           <p className="text-gray-600">You do not have permission to view this page.</p>
           <button 
             onClick={() => navigate('/admin/dashboard')}
             className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
           >
             Back to Dashboard
           </button>
        </div>
     );
  }

  return children;
};

export default ProtectedRoute;